import { PeanutOffIcon } from './PeanutOffIcon';

/**
 * author: Michael Richins
 * id D8BD17A2-5CE7-4219-8363-E87D80C2E7DF
 * name peanut-off
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/peanut-off.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const FoodAllergyOffIcon = PeanutOffIcon;
export default FoodAllergyOffIcon